(() => {
 if(window.ksTopCollections) return;
 window.ksTopCollections = true;
 document.addEventListener('click', async e => {
  const button=e.target.closest('[data-kc-copy]');
  if(!button)return;
  try {await navigator.clipboard.writeText(button.dataset.kcCopy);button.querySelector('span').textContent='Copied';document.querySelector('[data-kc-status]').textContent='KSCODE copied';}
  catch {button.querySelector('span').textContent='Use at checkout';}
 });
 function applySort(form) {
  const url = new URL(window.location.href);
  url.hash = '';
  url.searchParams.delete('page');
  for (const key of Array.from(url.searchParams.keys())) {
   if (key.startsWith('filter.')) url.searchParams.delete(key);
  }
  const values = new FormData(form);
  for (const key of new Set(values.keys())) url.searchParams.delete(key);
  for (const [key, value] of values) {
   if (typeof value === 'string' && value !== '') url.searchParams.append(key, value);
  }
  window.location.assign(url.toString());
 }
 document.addEventListener('change', e => {
  if (!e.target.matches('#kc-sort, #ks-search-sort')) return;
  e.stopImmediatePropagation();
  applySort(e.target.form);
 }, true);
 document.addEventListener('submit', e => {
  if (!e.target.matches('#kc-filter-form, .ks-search .kc-sort')) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  applySort(e.target);
 }, true);
})();
